import React, { useState,useEffect } from "react";
import "./SobhaOneWord.css";
import Swal from "sweetalert2";

// HEADER
import logo from "./assets/logo.png";
import darkLogo from "./assets/AM dark logo.png";
import whiteLogo from "./assets/white logo.png";
import lightLogo from "./assets/AM light logo.png";

// HERO / MAIN
import heroImg from "./assets/1.jpg";
import int8 from "./assets/int-8.jpg";
import int9 from "./assets/int-9.jpg";
import int13 from "./assets/int-13.jpg";

// GALLERY
import int1 from "./assets/int-1.jpg";
import int3 from "./assets/int-3.jpg";
import int4 from "./assets/int-4.jpg";
import int10 from "./assets/int-10.jpg";
import img40 from "./assets/40.jpg";
import img39 from "./assets/39.jpg";
import int5 from "./assets/int-5.jpg";
import int6 from "./assets/int-6.jpg";
import int12 from "./assets/int-12.jpg";

// MASTER PLAN / ZONES
import masterPlan from "./assets/3.jpg";
import zone1 from "./assets/4.jpg";
import zone2 from "./assets/6.jpg";
import zone3 from "./assets/7.jpg";
import zone4 from "./assets/8.jpg";
import zone5 from "./assets/9.jpg";

// INTERIOR
import img33 from "./assets/33.jpg";
import img34 from "./assets/34.jpg";
import img35 from "./assets/35.jpg";
import img36 from "./assets/36.jpg";
import img37 from "./assets/37.jpg";
import img38 from "./assets/38.jpg";

// CLUB
import int11 from "./assets/int-11.jpg";

// FLOOR PLANS
import img32 from "./assets/32.jpg";
import img30 from "./assets/30.jpg";
import img31 from "./assets/31.jpg";
import img29 from "./assets/29.jpg";
import img28 from "./assets/28.jpg";
import img25 from "./assets/25.jpg";
import img26 from "./assets/26.jpg";
import httpCommon from "../../../http-common";

// LOCATION
import neighbourhood from "./assets/neighbourhood.png";

function SobhaOneWord() {
  const [activeTab, setActiveTab] = useState("1bhk");
  const [submitStatus, setSubmitStatus] = useState("idle");

  useEffect(() => {
  // eslint-disable-next-line no-unused-expressions
  !(function(f,b,e,v,n,t,s){
    if(f.fbq)return;
    n=f.fbq=function(){
      n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments);
    };
    if(!f._fbq)f._fbq=n;
    n.push=n;
    n.loaded=!0;
    n.version='2.0';
    n.queue=[];
    t=b.createElement(e);
    t.async=!0;
    t.src=v;
    s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s);
  })(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', '1736148847796527');
  window.fbq('track', 'PageView');
}, []);


  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    interested: "",
    budget: "",
    buyingPlan: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
//console.log("formData___",formData)
  try {

    setSubmitStatus("submitting");
   const response = await httpCommon.post(
      "/list/request-callback",
      formData
    );

//console.log("response__form__",response)
    const data = response.data;
    //const data = await response.json();

    if (data.status === "success") {

        // Meta Lead Event
      window.fbq?.('track', 'Lead');
      setSubmitStatus("success");

       Swal.fire({
        icon: "success",
        title: "Enquiry Sent!",
        text: "Thank you for contacting us. Our team will get back to you soon.",
        confirmButtonText: "OK",
      });

      setFormData({
        name: "",
        phone: "",
        email: "",
        interested: "",
        budget: "",
        buyingPlan: "",
        message: "",
      });

      setTimeout(() => {
        setSubmitStatus("idle");
      }, 3000);

    } else {

      alert(data.message || "Failed to submit");

      setSubmitStatus("idle");
    }

  } catch (error) {

    console.error(error);

    alert("Something went wrong");

    setSubmitStatus("idle");
  }
};

  return (
    <div className="sp-design-one" style={{marginTop: "5rem"}}>
      <div className="sp-wrap">
        {/* HEADER */}
        <header className="sp-header">
          <a href="#" className="sp-header-logo sp-header-logo-left">
            <img src={logo} alt="Sobha OneWorld" />
          </a>

          <div className="sp-header-contact">
            <small>Call for Site Visit</small>
            <a href="tel:+918041234567">+91 9243 024 730</a>
          </div>

          <a href="#" className="sp-header-logo sp-header-logo-right">
            <img src={darkLogo} alt="Asset Makers" />
          </a>
        </header>

        {/* FULL IMAGE */}
        <div className="sp-full-img sp-img-frame tall">
          <img className="sp-img" src={int8} alt="Sobha OneWorld" />
        </div>

        {/* HIGHLIGHTS */}
        <div className="sp-highlights">
          <div className="sp-highlight-item">
            <div className="sp-hl-label">Starting Price</div>
            <div className="sp-hl-value">₹1.09 Cr*</div>
            <div className="sp-hl-sub">Onwards</div>
          </div>

          <div className="sp-highlight-item">
            <div className="sp-hl-label">Configurations</div>
            <div className="sp-hl-value">1, 2, 3 & 4 BHK</div>
            <div className="sp-hl-sub">Grande & Luxe</div>
          </div>

          <div className="sp-highlight-item">
            <div className="sp-hl-label">Total Units</div>
            <div className="sp-hl-value">5,406 Homes</div>
            <div className="sp-hl-sub">14 Towers · Phase 1</div>
          </div>

          <div className="sp-highlight-item">
            <div className="sp-hl-label">Tower Height</div>
            <div className="sp-hl-value">46–47 Floors</div>
            <div className="sp-hl-sub">Among tallest in corridor</div>
          </div>

          <div className="sp-highlight-item">
            <div className="sp-hl-label">Location</div>
            <div className="sp-hl-value">Hoskote</div>
            <div className="sp-hl-sub">Old Madras Road, Bangalore East</div>
          </div>

          <div className="sp-highlight-item">
            <div className="sp-hl-label">Possession</div>
            <div className="sp-hl-value">Dec 2031</div>
            <div className="sp-hl-sub">Bookings Open</div>
          </div>

          <div className="sp-highlight-item">
            <div className="sp-hl-label">Landscape Zones</div>
            <div className="sp-hl-value">5 Zones</div>
            <div className="sp-hl-sub">30+ Amenity Points</div>
          </div>

          <div className="sp-highlight-item">
            <div className="sp-hl-label">One Club</div>
            <div className="sp-hl-value">30+ Facilities</div>
            <div className="sp-hl-sub">Incl. 24 Guest Rooms</div>
          </div>
        </div>

        {/* HERO */}
        <section className="sp-hero">
          <div className="sp-hero-left">
            <img
              className="sp-img sp-hero-img"
              src={heroImg}
              alt="Sobha OneWorld"
            />
            <div className="sp-hero-badge">
              New Launch · Greater Whitefield, Bangalore
            </div>
          </div>

          <div className="sp-hero-right">
            <div className="sp-eyebrow">One Residences at</div>

            <h1 className="sp-hero-title">
              Sobha
              <br />
              OneWorld
            </h1>

            <p className="sp-hero-sub">
              Greater Whitefield — The City's Eastern Arch of Tomorrow. Old
              Madras Road, Hoskote. Starting ₹1.09 Cr* · Possession Dec 2031.
            </p>

            {/* FORM */}
            <div className="sp-form-label">Request a Callback</div>

            <form onSubmit={handleSubmit}>
              <div className="sp-field">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Full Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="sp-field">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Mobile Number"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="sp-field">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>

              <div className="sp-field">
                <select
                  name="interested"
                  value={formData.interested}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                    Interested In
                  </option>
                  <option>1 BHK (734 sq.ft)</option>
                  <option>2 BHK Luxe (1063 sq.ft)</option>
                  <option>2 BHK Grande (1204 sq.ft)</option>
                  <option>3 BHK Luxe (1510 sq.ft)</option>
                  <option>3 BHK Grande (1833 sq.ft)</option>
                  <option>4 BHK Grande/Luxe (2415 sq.ft)</option>
                  <option>Site Visit</option>
                </select>
              </div>
              <div className="sp-field">
              <select
                name="budget"
                value={formData.budget}
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  What is your budget?
                </option>

                <option>No Budget</option>

                <option>
                  1.5 Cr to 2.5 Cr
                </option>

                <option>
                  2.5 Cr to 3.5 Cr
                </option>

                <option>
                  3.5 Cr to 4.5 Cr
                </option>

                <option>
                  4.5 Cr to 5.5 Cr
                </option>

                <option>
                  6.5 Cr to 7.5 Cr
                </option>

                <option>
                  7.5 Cr+
                </option>

              </select>
            </div>

            <div className="sp-field">
              <select
                name="buyingPlan"
                value={formData.buyingPlan}
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  When are you planning to buy a home?
                </option>

                <option>
                  No Intention
                </option>

                <option>
                  Just Browsing
                </option>

                <option>
                  Immediately
                </option>

                <option>
                  Within 3-6 Months
                </option>

                <option>
                  Within 6-12 Months
                </option>

                <option>
                  Next Year Onwards
                </option>

              </select>
            </div>

              <div className="sp-field">
                <textarea
                  name="message"
                  placeholder="Any specific requirements? (optional)"
                  value={formData.message}
                  onChange={handleInputChange}
                />
              </div>

              <button
                type="submit"
                className="sp-btn-submit"
                disabled={submitStatus !== "idle"}
              >
                {submitStatus === "submitting" && "Submitting…"}
                {submitStatus === "success" && "✓ Enquiry Received!"}
                {submitStatus === "idle" && "Send Enquiry →"}
              </button>
              <p className="sp-form-note">Your data is safe. We don't spam.</p>
            </form>
          </div>
        </section>

        {/* ABOUT */}
        <section className="sp-section" style={{ padding: 0 }}>
          <div className="sp-about-grid">
            <div className="sp-about-img-stack">
              <div className="sp-img-frame">
                <img className="sp-img" src={int9} alt="about" />
              </div>

              <div className="sp-img-frame">
                <img className="sp-img" src={int13} alt="about" />
              </div>
            </div>

            <div className="sp-about-text-wrap">
              <div className="sp-eyebrow">About the Project</div>

              <h2 className="sp-section-title">
                Greater Whitefield's
                <br />
                <em>Arch of Tomorrow</em>
              </h2>

              <div className="sp-divider"></div>

              <p>
                Sobha OneWorld is a landmark 300-acre integrated township in
                Greater Whitefield — one of Bangalore's fastest-growing eastern
                corridors. Strategically located on Old Madras Road, Hoskote,
                just 5 minutes from NH 75.
              </p>

              <p>
                One Residences features 14 towers of 46–47 floors each, with
                5,406 ultra-luxury 1, 2, 3 & 4 BHK apartments. Every home is
                column-free with floor-to-ceiling kitchen tiling, walk-in
                closets, and private balconies off every master bedroom.
              </p>

              <div className="sp-about-stats">
                <div>
                  <div className="sp-stat-num">300</div>
                  <div className="sp-stat-label">Acre Township</div>
                </div>

                <div>
                  <div className="sp-stat-num">5,406</div>
                  <div className="sp-stat-label">Total Residences</div>
                </div>

                <div>
                  <div className="sp-stat-num">14</div>
                  <div className="sp-stat-label">Towers · 46–47 Floors</div>
                </div>

                <div>
                  <div className="sp-stat-num">5</div>
                  <div className="sp-stat-label">Landscape Zones</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* GALLERY */}
        <section className="sp-section sp-section-warm">
          <div className="sp-eyebrow">Project Gallery</div>

          <h2 className="sp-section-title">
            See It <em>Yourself</em>
          </h2>

          <div className="sp-divider"></div>

          <div className="sp-gallery-mosaic">
            <div className="sp-img-frame">
              <img className="sp-img" src={int1} alt="gallery" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={int3} alt="gallery" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={int4} alt="gallery" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={int10} alt="gallery" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={img40} alt="gallery" />
            </div>
          </div>

          <div className="sp-gallery-strip">
            <div className="sp-img-frame">
              <img className="sp-img" src={img39} alt="gallery" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={int5} alt="gallery" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={int6} alt="gallery" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={int12} alt="gallery" />
            </div>
          </div>
        </section>

        {/* MASTER PLAN */}
        <section className="sp-section">
          <div className="sp-eyebrow">Site Overview</div>

          <h2 className="sp-section-title">
            The <em>Master Plan</em>
          </h2>

          <div className="sp-divider"></div>

          <div className="sp-masterplan-img sp-img-frame">
            <img className="sp-img" src={masterPlan} alt="master plan" />
          </div>
        </section>

        {/* ZONES SECTION */}
        <section className="sp-section sp-section-warm">
          <div className="sp-eyebrow">Outdoor Living</div>

          <h2 className="sp-section-title">
            Five <em>Landscape Zones</em>
          </h2>

          <div className="sp-divider"></div>

          <div className="sp-zones-wrap">
            <div className="sp-zone-row img-left">
              <div className="sp-zone-blueprint sp-img-frame">
                <img className="sp-img" src={zone1} alt="zone 1" />
              </div>

              <div className="sp-zone-info">
                <div className="sp-zone-num">01</div>
                <div className="sp-zone-name">
                  Temperate <em>Enclave</em>
                </div>
                <span className="sp-zone-tag">Zone 1</span>

                <ul className="sp-zone-list">
                  <li>OneWorld Plaza</li>
                  <li>Festival Lawn</li>
                  <li>Activity Deck</li>
                  <li>Wellness Gardens</li>
                  <li>Observation Deck</li>
                  <li>Leisure Pool</li>
                  <li>Kids Pool</li>
                </ul>
              </div>
            </div>

            <div className="sp-zone-row img-right">
              <div className="sp-zone-info warm">
                <div className="sp-zone-num">02</div>
                <div className="sp-zone-name">
                  Mediterranean <em>Serenity</em>
                </div>
                <span className="sp-zone-tag">Zone 2</span>

                <ul className="sp-zone-list">
                  <li>Oasis Trail</li>
                  <li>Dry Stream</li>
                  <li>Tuscan Gardens</li>
                  <li>Exhibition Square</li>
                  <li>Amphitheatre</li>
                  
                </ul>
              </div>

              <div className="sp-zone-blueprint sp-img-frame">
                <img className="sp-img" src={zone2} alt="zone 2" />
              </div>
            </div>

            <div className="sp-zone-row img-left">
              <div className="sp-zone-blueprint sp-img-frame">
                <img className="sp-img" src={zone3} alt="zone 3" />
              </div>

              <div className="sp-zone-info">
                <div className="sp-zone-num">03</div>
                <div className="sp-zone-name">
                  Tropical <em>Zen</em>
                </div>
                <span className="sp-zone-tag">Zone 3</span>

                <ul className="sp-zone-list">
                  <li>Tranquility Falls</li>
                  <li>Lagoon Cove</li>
                  <li>Reflexology Walk</li>
                  <li>Rainforest Field</li>
                  <li>Yoga Lawn</li>
                  <li>Zen Courtyard</li>
                  <li>Play Park</li>
                  <li>Skating Rink</li>
                  <li>Tropicana Gardens</li>
                </ul>
              </div>
            </div>

            <div className="sp-zone-row img-right">
              <div className="sp-zone-info warm">
                <div className="sp-zone-num">04</div>
                <div className="sp-zone-name">
                  World <em>Stadium</em>
                </div>
                <span className="sp-zone-tag">Zone 4</span>

                <ul className="sp-zone-list">
                  <li>Jogging / Cycling Track</li>
                  <li>Celebration Field</li>
                  <li>Cricket Grounds</li>
                  <li>Football Field</li>
                  <li>Running Track</li>
                  
                </ul>
              </div>

              <div className="sp-zone-blueprint sp-img-frame">
                <img className="sp-img" src={zone4} alt="zone 4" />
              </div>
            </div>

            <div className="sp-zone-row img-left">
              <div className="sp-zone-blueprint sp-img-frame">
                <img className="sp-img" src={zone5} alt="zone 5" />
              </div>

              <div className="sp-zone-info">
                <div className="sp-zone-num">05</div>
                <div className="sp-zone-name">
                  Continental <em>Grounds</em>
                </div>
                <span className="sp-zone-tag">Zone 5</span>

                <ul className="sp-zone-list">
                  <li>Pickleball Courts</li>
                  <li>Play Lawn</li>
                  <li>Tennis Courts</li>
                  <li>Multi-Sport Court</li>
                  <li>Fitness Lawn</li>
                  <li>Pet Park</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* INTERIORS */}
        <section className="sp-section">
          <div className="sp-eyebrow">Inside Your Home</div>

          <h2 className="sp-section-title">
            Crafted <em>Interiors</em>
          </h2>

          <div className="sp-divider"></div>

          <div className="sp-interiors">
            <div className="sp-img-frame">
              <img className="sp-img" src={img33} alt="interior" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={img34} alt="interior" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={img35} alt="interior" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={img36} alt="interior" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={img37} alt="interior" />
            </div>

            <div className="sp-img-frame">
              <img className="sp-img" src={img38} alt="interior" />
            </div>
          </div>
        </section>

        {/* CLUB */}
        <section className="sp-section sp-section-warm">
          <div className="sp-eyebrow">Residents Club</div>

          <h2 className="sp-section-title">
            The <em>One Club</em>
          </h2>

          <div className="sp-divider"></div>

          <div className="sp-club-hero sp-img-frame">
            <img className="sp-img" src={int11} alt="club" />
          </div>

          <div className="sp-club-grid2">
            <div className="sp-club-item">
              <i className="fas fa-utensils"></i>
              <span>Restaurant</span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-coffee"></i>
              <span>Café</span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-film"></i>
              <span>Mini Theatre (2 Nos.)</span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-swimming-pool"></i>
              <span>Indoor Pool</span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-dumbbell"></i>
              <span>Gymnasium</span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-blender"></i>
              <span>Lobby & Juice Centre</span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-spa"></i>
              <span>Yoga / Meditation Hall </span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-table-tennis"></i>
              <span>Table Tennis Halls (5 Nos.)</span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-racquet"></i>
              <span>Squash Court</span>
            </div>
            <div className="sp-club-item">
              <i className="fas fa-shuttlecock"></i>
              <span>Badminton Halls (5 Nos.)</span>
            </div>
             <div className="sp-club-item">
              <i className="fas fa-child"></i>
              <span>Indoor Kids' Play Area</span>
            </div>
              <div className="sp-club-item">
              <i className="fas fa-circle"></i>
              <span>Billiards & Pool Tables</span>
            </div>

             <div className="sp-club-item">
              <i className="fas fa-briefcase"></i>
              <span>Business Lounge</span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-laptop"></i>
              <span>Co-working Space</span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-chalkboard"></i>
              <span>Conference Room</span>
            </div> 

            <div className="sp-club-item">
              <i className="fas fa-running"></i>
              <span>Aerobic Hall</span>
            </div>  

            <div className="sp-club-item">
              <i className="fas fa-book"></i>
              <span>Reading Hall </span>
            </div> 

            <div className="sp-club-item">
              <i className="fas fa-users"></i>
              <span>Senior Citizen Hall</span>
            </div> 
            <div className="sp-club-item">
              <i className="fas fa-baby"></i>
              <span>Crèche (2 Nos.)</span>
            </div> 

            <div className="sp-club-item">
              <i className="fas fa-chalkboard-teacher"></i>
              <span>Learning Hall (4 Nos.)</span>
            </div> 
            <div className="sp-club-item">
              <i className="fas fa-concierge-bell"></i>
              <span>Grand Hospitality Lobbies</span>
            </div>

            <div className="sp-club-item">
              <i className="fas fa-bed"></i>
              <span>Guest Rooms (24 Nos.)</span>
            </div> 
            <div className="sp-club-item">
              <i className="fas fa-tshirt"></i>
              <span>Laundromat</span>
            </div> 
            <div className="sp-club-item">
              <i className="fas fa-gamepad"></i>
              <span>Indoor Games</span>
            </div>
            <div className="sp-club-item">
              <i className="fas fa-users"></i>
              <span>Multi-purpose Halls (3 Nos.)</span>
            </div> 
             <div className="sp-club-item">
              <i className="fas fa-couch"></i>
              <span>Lounge</span>
            </div> 
            <div className="sp-club-item">
              <i className="fas fa-headset"></i>
              <span>Reading Lounge & Crèche</span>
            </div> 

          </div>
        </section>

        {/* FLOOR PLANS */}
        <section className="sp-section">
          <div className="sp-eyebrow">Unit Plans</div>

          <h2 className="sp-section-title">
            Choose Your <em>Home</em>
          </h2>

          <div className="sp-divider"></div>

          <div className="sp-tabs">
            <button
              className={`sp-tab ${activeTab === "1bhk" ? "active" : ""}`}
              onClick={() => setActiveTab("1bhk")}
            >
              1 BHK
            </button>
            <button
              className={`sp-tab ${activeTab === "2bhk-luxe" ? "active" : ""}`}
              onClick={() => setActiveTab("2bhk-luxe")}
            >
              2 BHK Luxe
            </button>
            <button
              className={`sp-tab ${activeTab === "2bhk-grande" ? "active" : ""}`}
              onClick={() => setActiveTab("2bhk-grande")}
            >
              2 BHK Grande
            </button>
            <button
              className={`sp-tab ${activeTab === "3bhk-luxe" ? "active" : ""}`}
              onClick={() => setActiveTab("3bhk-luxe")}
            >
              3 BHK Luxe
            </button>
            <button
              className={`sp-tab ${activeTab === "3bhk-grande" ? "active" : ""}`}
              onClick={() => setActiveTab("3bhk-grande")}
            >
              3 BHK Grande
            </button>
            <button
              className={`sp-tab ${activeTab === "4bhk-grande" ? "active" : ""}`}
              onClick={() => setActiveTab("4bhk-grande")}
            >
              4 BHK Grande
            </button>
             <button
              className={`sp-tab ${activeTab === "4bhk-luxe" ? "active" : ""}`}
              onClick={() => setActiveTab("4bhk-luxe")}
            >
              4 BHK Luxe
            </button>
          </div>

          {/* 1 BHK */}
          {activeTab === "1bhk" && (
            <div className="sp-tab-panel active">
              <div className="sp-plan-img sp-img-frame">
                <img className="sp-img" src={img32} alt="plan" />
              </div>

              <div className="sp-plan-info">
                <h3>1 Bedroom</h3>

                <span className="sp-plan-type">Standard</span>

                <ul className="sp-plan-features">
                  <li>
                    <span>SBA per Unit</span>
                    <span>734.05 sq.ft</span>
                  </li>

                  <li>
                    <span>Carpet Area</span>
                    <span>432.28 sq.ft</span>
                  </li>

                  <li>
                    <span>Bedrooms</span>
                    <span>1</span>
                  </li>

                  <li>
                    <span>Bathrooms</span>
                    <span>1</span>
                  </li>

                  <li>
                    <span>Balcony</span>
                    <span>1</span>
                  </li>

                  <li>
                    <span>Wings</span>
                    <span>Wing 9, Wing 14</span>
                  </li>

                  
                </ul>

                <div className="sp-plan-price">
                  <div className="label">Starting at</div>
                  <div className="amount">From ₹1.09 Cr*</div>
                </div>
              </div>
            </div>
          )}

          {/* 2 BHK LUXE */}
          {activeTab === "2bhk-luxe" && (
            <div className="sp-tab-panel active">
              <div className="sp-plan-img sp-img-frame">
                <img className="sp-img" src={img30} alt="plan" />
              </div>

              <div className="sp-plan-info">
                <h3>2 Bedroom</h3>

                <span className="sp-plan-type">Luxe</span>

                <ul className="sp-plan-features">
                  <li>
                    <span>SBA per Unit</span>
                    <span>1063.23 sq.ft</span>
                  </li>

                  <li>
                    <span>Carpet Area</span>
                    <span>648.32 sq.ft</span>
                  </li>

                  <li>
                    <span>Bedrooms</span>
                    <span>2</span>
                  </li>

                  <li>
                    <span>Bathrooms</span>
                    <span>2</span>
                  </li>

                  <li>
                    <span>Balcony</span>
                    <span>1</span>
                  </li>

                  <li>
                    <span>Wings</span>
                    <span>Wings 10–13</span>
                  </li>
                </ul>

                <div className="sp-plan-price">
                  <div className="label">Starting at</div>
                  <div className="amount">From ₹1.09 Cr*</div>
                </div>
              </div>
            </div>
          )}

          {/* 2 BHK GRANDE */}
          {activeTab === "2bhk-grande" && (
            <div className="sp-tab-panel active">
              <div className="sp-plan-img sp-img-frame">
                <img className="sp-img" src={img31} alt="plan" />
              </div>

              <div className="sp-plan-info">
                <h3>2 Bedroom</h3>

                <span className="sp-plan-type">Grande</span>

                <ul className="sp-plan-features">
                  <li>
                    <span>SBA per Unit</span>
                    <span>1204.92 sq.ft</span>
                  </li>

                  <li>
                    <span>Carpet Area</span>
                    <span>743.04 sq.ft</span>
                  </li>

                  <li>
                    <span>Bathrooms</span>
                    <span>2 </span>
                  </li>

                  <li>
                    <span>Bathrooms</span>
                    <span>2</span>
                  </li>

                  <li>
                    <span>Balcony</span>
                    <span>1</span>
                  </li>

                  <li>
                    <span>Wings</span>
                    <span>Wings 10, 13</span>
                  </li>
                </ul>

                <div className="sp-plan-price">
                  <div className="label">Starting at</div>
                  <div className="amount">From ₹1.09 Cr*</div>
                </div>
              </div>
            </div>
          )}

          {/* 3 BHK LUXE */}
          {activeTab === "3bhk-luxe" && (
            <div className="sp-tab-panel active">
              <div className="sp-plan-img sp-img-frame">
                <img className="sp-img" src={img29} alt="plan" />
              </div>

              <div className="sp-plan-info">
                <h3>3 Bedroom</h3>

                <span className="sp-plan-type">Luxe</span>

                <ul className="sp-plan-features">
                  <li>
                    <span>SBA per Unit</span>
                    <span>1510.70 sq.ft</span>
                  </li>

                  <li>
                    <span>Carpet Area</span>
                    <span>960.04 sq.ft</span>
                  </li>

                  <li>
                    <span>Bedrooms</span>
                    <span>3</span>
                  </li>

                  <li>
                    <span>Bathrooms</span>
                    <span>3</span>
                  </li>

                  <li>
                    <span>Balcony</span>
                    <span>1</span>
                  </li>

                  <li>
                    <span>Wings</span>
                    <span>Wings 9–14</span>
                  </li>
                </ul>

                <div className="sp-plan-price">
                  <div className="label">Starting at</div>
                  <div className="amount">From ₹1.09 Cr*</div>
                </div>
              </div>
            </div>
          )}

          {/* 3 BHK GRANDE */}
          {activeTab === "3bhk-grande" && (
            <div className="sp-tab-panel active">
              <div className="sp-plan-img sp-img-frame">
                <img className="sp-img" src={img28} alt="plan" />
              </div>

              <div className="sp-plan-info">
                <h3>3 Bedroom</h3>

                <span className="sp-plan-type">Grande</span>

                <ul className="sp-plan-features">
                  <li>
                    <span>SBA per Unit</span>
                    <span>1833.67 sq.ft</span>
                  </li>

                  <li>
                    <span>Carpet Area</span>
                    <span>1110.74 sq.ft</span>
                  </li>

                  <li>
                    <span>Bedrooms</span>
                    <span>3</span>
                  </li>

                  <li>
                    <span>Bathrooms</span>
                    <span>3</span>
                  </li>

                  <li>
                    <span>Balcony</span>
                    <span>2 (incl. master)</span>
                  </li>

                  <li>
                    <span>Wings</span>
                    <span>Wings 1, 2</span>
                  </li>
                </ul>

                <div className="sp-plan-price">
                  <div className="label">Starting at</div>
                  <div className="amount">From ₹1.09 Cr*</div>
                </div>
              </div>
            </div>
          )}

          {/* 4 BHK grande*/}
          {activeTab === "4bhk-grande" && (
            <div className="sp-tab-panel active">
              <div className="sp-plan-img sp-img-frame">
                <img className="sp-img" src={img25} alt="plan" />
              </div>

              <div className="sp-plan-info">
                <h3>4 Bedroom</h3>

                <span className="sp-plan-type">Grande</span>

                <ul className="sp-plan-features">
                  <li>
                    <span>SBA per Unit</span>
                    <span>2415.77 sq.ft</span>
                  </li>

                  <li>
                    <span>Carpet Area</span>
                    <span>1488.02 sq.ft</span>
                  </li>

                  <li>
                    <span>Bedrooms</span>
                    <span>4</span>
                  </li>

                  <li>
                    <span>Bathrooms</span>
                    <span>4</span>
                  </li>

                  <li>
                    <span>Balcony</span>
                    <span>2</span>
                  </li>

                  <li>
                    <span>Wings</span>
                    <span>Wing 1 (45 units), Wing 2 (90 units)</span>
                  </li>
                </ul>

                <div className="sp-plan-price">
                  <div className="label">Starting at</div>
                  <div className="amount">From ₹1.09 Cr*</div>
                </div>
              </div>
            </div>
          )}
          {/* 4 BHK luxe*/}
          {activeTab === "4bhk-luxe" && (
            <div className="sp-tab-panel active">
              <div className="sp-plan-img sp-img-frame">
                <img className="sp-img" src={img26} alt="plan" />
              </div>

              <div className="sp-plan-info">
                <h3>4 Bedroom</h3>

                <span className="sp-plan-type">Luxe</span>

                <ul className="sp-plan-features">
                  <li>
                    <span>SBA per Unit</span>
                    <span>2415.77 sq.ft</span>
                  </li>

                  <li>
                    <span>Carpet Area</span>
                    <span>1485.54 sq.ft</span>
                  </li>

                  <li>
                    <span>Bedrooms</span>
                    <span>4</span>
                  </li>

                  <li>
                    <span>Bathrooms</span>
                    <span>4</span>
                  </li>

                  <li>
                    <span>Balcony</span>
                    <span>2</span>
                  </li>

                  <li>
                    <span>Wings</span>
                    <span>Wing 1 (45 units)</span>
                  </li>
                </ul>

                <div className="sp-plan-price">
                  <div className="label">Starting at</div>
                  <div className="amount">From ₹1.09 Cr*</div>
                </div>
              </div>
            </div>
          )}
        </section>

        {/* NEIGHBOURHOOD */}
        <section className="sp-section sp-section-warm">
          <div className="sp-eyebrow">The Neighbourhood</div>

          <h2 className="sp-section-title">
            Everything <em>Close By</em>
          </h2>

          <div className="sp-divider"></div>

          <div className="sp-nbr-grid">
            <div className="sp-nbr-col">
              <div className="sp-nbr-col-title">
                <i className="fas fa-graduation-cap"></i> Education
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">5 min</div>
                <div className="sp-nbr-places">Eurokids Pre-School, VIBGYOR High School</div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">10 min</div>
                <div className="sp-nbr-places">Chrysalis High School, New Baldwin Int'l School, Klay BST</div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">15 min</div>
                <div className="sp-nbr-places">
                  The Polaris Int'l School
                </div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">20 min</div>
                <div className="sp-nbr-places">
                  DPS Whitefield Mallasandra, National Public School, Oracle Public School
                </div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">25 min</div>
                <div className="sp-nbr-places">
                 Global Residential School, Birla Open Minds Int'l, Eqube Int'l School
                </div>
              </div>
              <div className="sp-nbr-group">
                <div className="sp-nbr-time">30 min</div>
                <div className="sp-nbr-places">
                 The Brigade School, Focus Academy Global School
                </div>
              </div>
            </div>

            <div className="sp-nbr-col">
              <div className="sp-nbr-col-title">
                <i className="fas fa-hospital"></i> Healthcare
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">10 min</div>
                <div className="sp-nbr-places">
                  Motherhood Clinic, MVJ Hospital
                </div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">15 min</div>
                <div className="sp-nbr-places">East Point Hospital</div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">30 min</div>
                <div className="sp-nbr-places">Manipal Hospital, Aster Whitefield Hospital, Vydehi Hospital</div>
              </div>

              
            </div>

            <div className="sp-nbr-col">
              <div className="sp-nbr-col-title">
                <i className="fas fa-building"></i> Offices
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">5 min</div>
                <div className="sp-nbr-places">Bearys Global Research Triangle</div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">10 min</div>
                <div className="sp-nbr-places">Brigade Signature Towers</div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">25 min</div>
                <div className="sp-nbr-places">GR Tech Park, ITPL</div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">30 min</div>
                <div className="sp-nbr-places">
                  EPIP Zone, Bagmane World Technology Centre, RMZ 
                  Infinity, KIADB Aerospace Park
                </div>
              </div>
            </div>

            <div className="sp-nbr-col">
              <div className="sp-nbr-col-title">
                <i className="fas fa-shopping-bag"></i> Leisure
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">5 min</div>
                <div className="sp-nbr-places">Orion Uptown Mall</div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">10 min</div>
                <div className="sp-nbr-places">Decathlon, SBR Horizon</div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">25 min</div>
                <div className="sp-nbr-places">
                  Park Square Mall, Gopalan Signature Mall, VR Bengaluru,
                   Phoenix Marketcity
                </div>
              </div>

              <div className="sp-nbr-group">
                <div className="sp-nbr-time">30 min</div>
                <div className="sp-nbr-places">Inorbit Mall, Nexus Shantiniketan Mall</div>
              </div>
            </div>
          </div>
        </section>

        {/* INFRASTRUCTURE */}
        <section className="sp-section">
          <div className="sp-eyebrow">Future-ready Horizon</div>

          <h2 className="sp-section-title">
            Infrastructure <em>Coming Up</em>
          </h2>

          <div className="sp-divider"></div>

          <div className="sp-infra-grid">
            <div className="sp-infra-item">
              <div className="sp-infra-icon">
                <i className="fas fa-tunnel"></i>
              </div>
              <div className="sp-infra-name">
                The Bengaluru
                <br />
                <strong>Business Corridor</strong>
              </div>
            </div>

            <div className="sp-infra-item">
              <div className="sp-infra-icon">
                <i className="fas fa-road"></i>
              </div>
              <div className="sp-infra-name">
                Upcoming Satellite
                <br />
                <strong>Town Ring Road</strong>
              </div>
            </div>

            <div className="sp-infra-item">
              <div className="sp-infra-icon">
                <i className="fas fa-train"></i>
              </div>
              <div className="sp-infra-name">
                43 km
                <br />
                <strong>Purple Metro Line</strong>
              </div>
            </div>

            <div className="sp-infra-item">
              <div className="sp-infra-icon">
                <i className="fas fa-route"></i>
              </div>
              <div className="sp-infra-name">
                Bangalore–Chennai
                <br />
                <strong>Expressway</strong>
              </div>
            </div>
          </div>
        </section>

        {/* LOCATION */}
        <section className="sp-section sp-section-warm">
          <div className="sp-eyebrow">Location Advantage</div>

          <h2 className="sp-section-title">
            Perfectly <em>Connected</em>
          </h2>

          <div className="sp-divider"></div>

          <div className="sp-location-grid">
            <div className="sp-map-ph sp-img-frame">
              <img className="sp-img" src={neighbourhood} alt="map" />
            </div>

            <div>
              <ul className="sp-distances">
                <li className="sp-distance-item">
                  <span className="place">
                    <i className="fa-solid fa-plane"></i> Kempegowda Int'l Airport
                  </span>

                  <span className="dist">~45 mins</span>
                </li>

                <li className="sp-distance-item">
                  <span className="place">
                    <i className="fas fa-road"></i> Old Madras Road (NH 75)
                  </span>

                  <span className="dist">Direct Access</span>
                </li>

                <li className="sp-distance-item">
                  <span className="place">
                    <i className="fas fa-map-marker-alt"></i> KR Puram
                  </span>

                  <span className="dist">~15 mins</span>
                </li>

                <li className="sp-distance-item">
                  <span className="place">
                    <i className="fas fa-map-marker-alt"></i> Whitefield
                  </span>

                  <span className="dist">~20 mins</span>
                </li>

                <li className="sp-distance-item">
                  <span className="place">
                    <i className="fas fa-building"></i> ITPL / Whitefield IT Hub
                  </span>

                  <span className="dist">~25 mins</span>
                </li>

                <li className="sp-distance-item">
                  <span className="place">
                    <i className="fas fa-water"></i> Hoskote Lake
                  </span>

                  <span className="dist">~5 mins</span>
                </li>

                <li className="sp-distance-item">
                  <span className="place">
                    <i className="fas fa-shopping-cart"></i> Orion Uptown Mall
                  </span>

                  <span className="dist">~5 mins</span>
                </li>

                <li className="sp-distance-item">
                  <span className="place">
                    <i className="fas fa-city"></i> MG Road, Bangalore
                  </span>

                  <span className="dist">~50 mins</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="sp-footer">
          <div className="sp-footer-left">
            <div className="sp-footer-logos">
              <img src={whiteLogo} alt="white logo" />
              <img src={lightLogo} alt="light logo" />
            </div>

            <p className="sp-footer-text">
              Asset Makers is an authorised channel partner for Sobha OneWorld.
              Prices are indicative and subject to change without notice. Images
              and renders are for representational purposes only.
            </p>
          </div>

          <div className="sp-footer-right">
            <a className="sp-footer-phone" href="tel:+918041234567">
              +91 9243 024 730
            </a>

            <p className="sp-footer-address">
              Old Madras Road, Hoskote
              <br />
              Greater Whitefield, Bangalore East
              <br />
              Karnataka – 562 114
            </p>
          </div>
        </footer>

        <div className="sp-footer-bottom">
          © 2025 Sobha OneWorld. All rights reserved. Asset Makers is a channel
          partner. For information purposes only. | RERA No.:
          PRM/KA/RERA/XXXX/XXXX | Greater Whitefield, Bangalore East
        </div>
      </div>
    </div>
  );
}

export default SobhaOneWord;